var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty_component"},[_c('img',{attrs:{"width":_vm.imgWidth,"src":require("@/assets/imgs/mobile/empty.png"),"alt":""}}),_c('div',{staticClass:"empty_text"},[_vm._v("没有找到数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }